export default "__VITE_ASSET__aMXgF596__"